import React from 'react';
// import { Link } from "react-router-dom";
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Timeline from '../elements/Timeline';
import TimelineItem from '../elements/TimelineItem';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

class Roadmap extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'roadmap section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'roadmap-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );


    // const headerButton = () => {
    //   return (
    //     <>Would you like to discuss the possibility of working together? Please 
    //     <Link
    //         to='#'
    //         onClick={(e) => {
    //             window.location = 'mailto:contact@arnoldfreitas.com';
    //             // e.preventDefault();
    //         }}
    //     >
    //         send me an e-mail
    //     </Link>  and we will schedule a talk. Roughly, our project will follow the roadmap below.</>
    //   )};


    const sectionHeader = {
        title: 'How We Work Together',
        paragraph: 'Interested in building something together? Reach out and we\'ll schedule an initial call. Here\'s what the engagement typically looks like.'
      };

    const sectionContent = [
    {
      title: 'Scoping the Problem',
      paragraph: 'We start with a direct conversation about your challenge, current systems, and business objectives. I ask the questions that matter: what exists, what\'s broken, what success looks like, and what constraints apply — technical, regulatory, or organizational.'
    },
    {
      title: 'Architecture & Approach',
      paragraph: 'Based on your requirements, I define the system architecture: which LLM approach fits, what infrastructure is appropriate, and how the solution integrates with your existing stack. You get a concrete technical plan before a single line of code is written.'
    },
    {
      title: 'Engineering & Build',
      paragraph: 'I design and develop the system — whether that\'s a RAG pipeline, agentic workflow, automation platform, or custom AI API. Built for production from day one: clean architecture, documented code, and deployability by design.'
    },
    {
      title: 'Deployment & Validation',
      paragraph: 'The solution is deployed into your environment — cloud, on-premise, or hybrid — and validated against real data and user scenarios. Performance, accuracy, and compliance requirements are verified before handoff.'
    },
    {
      title: 'Handoff & Ongoing Support',
      paragraph: 'You receive a fully operational system with documentation and a clear operational handoff. I remain available for post-deployment support, monitoring guidance, and future iterations as your needs evolve.'
    },
    // {
    //   title: '',
    //   paragraph: ''
    // },
    ];

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content" />
            <Timeline>
              {sectionContent.map((item,i)=> 
               <TimelineItem key={i} title={item.title}>
                {item.paragraph}
               </TimelineItem>
              )}
            </Timeline>
          </div>
        </div>
      </section>
    );
  }
}

Roadmap.propTypes = propTypes;
Roadmap.defaultProps = defaultProps;

export default Roadmap;